import scrollService from '../services.common/scrollService';

export default class EcardPreviewModal extends HTMLElement {
    constructor() {
        super();
        this._initialOptionsAmount = 6;
        this._viewMoreStep = 4;
        this._formData = null;
        this._visibleOptions = [];
        this._hasMultiple = this.dataset.count !== "1";
        this._submitButton = this.querySelector("[data-submit-button]");
        this._beginPreview = this._beginPreview.bind(this);
        this._handleInput = this._handleInput.bind(this);
        this._returnToList = this._returnToList.bind(this);
        this._viewAll = this._viewAll.bind(this);
        this._viewMore = this._viewMore.bind(this);

        if(this._hasMultiple === false) {
            return;
        }

        this._form = this.querySelector("form");
        this._detailSection = this.querySelector("[data-detail-section]");
        this._submitSection = this.querySelector("[data-submit-section]");
        this._selectedNameElement = this.querySelector("[data-selected-name]");
        this._returnButton = this.querySelector("[data-return-button]");
        this._recipientOptions = Array.from(this.querySelectorAll(".ecard-preview-modal__label"));
        this._cardRecipientName = document.querySelector(".ecard-preview__recipient");        
        this._viewMoreButton = this.querySelector("[data-view-more]");
        this._viewAllButton = this.querySelector("[data-view-all]");
        this._previewRecipientName = document.querySelector("[data-recipient-name]");
    }
    
    connectedCallback() {
        this._submitButton.addEventListener("click", this._beginPreview);
        scrollService.disableBodyScroll(this);

        if(this._hasMultiple === false) {
            return;
        }
        this._recipientOptions.slice(0, Math.min(this._recipientOptions.length, this._initialOptionsAmount)).forEach(option => {
            option.classList.add("visible");
            this._visibleOptions.push(option);
        });
        this._detailSection.classList.add("hidden");
        this._submitSection.classList.add("hidden");
        this._form.addEventListener("click", this._handleInput);
        this._returnButton.addEventListener("click", this._returnToList);

        if (this._viewAllButton === null || this._viewMoreButton === null) {
            return;
        }
        this._viewAllButton.addEventListener("click", this._viewAll);
        this._viewMoreButton.addEventListener("click", this._viewMore);
    }

    _beginPreview(e) {
        e.preventDefault();
        scrollService.clearAllBodyScrollLocks();
        this.classList.add("closed");
    }

    _handleInput(e) {
        this._formData = new FormData(this._form);
        this._selectedName = this._formData.get("recipient-name");
        this._selectedNameElement.innerHTML = this._selectedName;
        this._cardRecipientName.innerHTML = `To ${this._selectedName}`;
        this._previewRecipientName.innerHTML = this._selectedName;
        this._form.classList.add("hidden");
        this._detailSection.classList.remove("hidden");
        this._submitSection.classList.remove("hidden");
    }

    _returnToList() {
        this._form.classList.remove("hidden");
        this._detailSection.classList.add("hidden");
        this._submitSection.classList.add("hidden");
    }

    _viewAll() {
        this._recipientOptions.slice(this._visibleOptions.length, this._recipientOptions.length).forEach(option => {
            option.classList.add("visible");
            this._visibleOptions.push(option);
        });
        this._hideViewMoreButtons();
    }

    _viewMore() {
        this._recipientOptions.slice(this._visibleOptions.length, this._visibleOptions.length + this._viewMoreStep).forEach(option => {
            option.classList.add("visible");
            this._visibleOptions.push(option);
        });
        this._viewMoreStep = 10;

        if(this._visibleOptions.length >= this._recipientOptions.length) {
            this._hideViewMoreButtons();
        }
    }

    _hideViewMoreButtons() {
        if (this._viewAllButton === null || this._viewMoreButton === null) {
            return;
        }
        this._viewAllButton.style.display = "none";
        this._viewMoreButton.style.display = "none";
    }

    disconnectedCallback() {
        scrollService.clearAllBodyScrollLocks();
        this._form.removeEventListener("change", this._handleInput);
        this._returnButton.removeEventListener("click", this._returnToList);
        this._viewAllButton.removeEventListener("click", this._viewAll);
        this._viewMoreButton.removeEventListener("click", this._viewMore);
        this._submitButton.removeEventListener("click", this._beginPreview);
    }

}

customElements.define("ecard-preview-modal", EcardPreviewModal);
